import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { AjaxSourcedDataHeading } from "../../../../Constant";
import { AJAX_DATA_COLUMN, AJAX_SOURCE_DATA, AJAX_SOURCE_DATA_LIST } from "../../../../Data/DataTable/DataSourceData";

const AjaxSourcedData = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={AjaxSourcedDataHeading} span={AJAX_SOURCE_DATA} />
        <CardBody>
          <div className="table-responsive">
          <DataTable data={AJAX_SOURCE_DATA_LIST} columns={AJAX_DATA_COLUMN} striped highlightOnHover pagination className="display"/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AjaxSourcedData;
